import React from 'react'
import {Redirect} from 'react-router-dom'
import {LOGIN, MANAGE_PROCUREMENTS} from '../routes'
import {hasTokenFromLocalStorage} from './../helpers/token'

const Home = ({isLoggedIn}) => {
	if(hasTokenFromLocalStorage()) {
		return	<Redirect to={MANAGE_PROCUREMENTS} />
	}
	return <Redirect to={LOGIN} />
}

export default Home


// WEBPACK FOOTER //
// ./src/components/Home.js